import { checkConfigFrom, checkCoupnMatchConfig, getSessionConfig } from '@/service/strategy/dataStorage';
import { canShowAnyPop, canShowThisPop } from '@/service/strategy/priority';
import { canShowIconBeforeWithFrequency } from '@/service/strategy/iconTiming';
import { terminal } from '@/constant/index';
import { companyUUID, deleteDOM } from '@/service/api';
import { showFromTriggerList } from '@/service/strategy/show';
import { POVISON, SMALLRIG, STORAGE_KEY } from '@/constant/constant';
import { debug } from 'debug';
import { common } from '@/constant/company';
import { formEventV2 } from '@/service/formEventV2';
import { isInPage } from '@/utils/common';
import { safeJsonParse } from '@/utils/safeJsonParse';
import { getLocal, getSession, removeLocal, removeSession, setSession } from '@/utils/storage';
import { isShopifyOrTest, isShoplazzaOrTest, isShoplineOrTest, isCommonSimpleOrTest, isCommonOrTest, isSimpleOrTest, isWooCommerceOrTest, isSaaSPlatform } from '@/utils/platform';
import { popupFlowLog } from '@/utils/popupFlowDebug';
import { showIcon } from '@/service/strategy/iconLogic';

const log = debug('cartsee:logic');

const matchUrlPart = (pathname, hostname, paramseters, url) => {
  // 处理url
  let url1 = url;
  url1 = url1.replaceAll('https://', '');
  url1 = url1.replaceAll('http://', '');
  url1 = url1.replaceAll('www.', '');
  // 替换？为\\？
  if (url1) {
    url1 = url1.replaceAll('?', '\\?');
  }
  let result = '';
  let hasOther = false;
  for (let i = 0; i < url1?.length; i++) {
    const chart = url1[i];
    if (chart === '*' && !hasOther) {
      continue;
    } else {
      hasOther = true;
      result = result + chart;
    }
  }
  // 前后加正则
  const regStr = '(?:.*)' + result + '(?:.*)';
  const reg = new RegExp(regStr);

  // 如果有host 判断
  if (hostname) {
    return reg.test(hostname + pathname + paramseters);
  } else {
    return reg.test(pathname);
  }
};

const matchExactUrl = (pathname, hostname, paramseters, urlItem) => {
  // url处理
  urlItem.url = urlItem.url.replaceAll('https://', '');
  urlItem.url = urlItem.url.replaceAll('http://', '');
  urlItem.url = urlItem.url.replaceAll('www.', '');

  // 不包含？
  const dontHasSearch = !urlItem.url.includes('?');

  // 如果不勾选完全匹配 或 不包含？
  if (!urlItem.completeMatching || dontHasSearch) {
    // hostname 没有值
    if (hostname.length === 0) {
      // 只判断path
      if (pathname === urlItem.url) {
        return true;
      } else {
        // 下一个url判断
        return false;
      }
    } else {
      // 只取？前边的
      let urlArr = urlItem.url.split('');
      const searchIndex = urlArr.findIndex((x) => x === '?');
      if (searchIndex !== -1) {
        urlArr = urlArr.map((x, idx) => (idx < searchIndex ? x : ''));
      }
      let nUrl = urlArr.join('');
      let count = (urlArr.filter((item) => item === '/') || []).length;
      // 如果？前边的不包含/ 且 pathname == /
      if ('/' === pathname && !nUrl.includes('/')) {
        nUrl = nUrl + '/';
      } else if ('' === pathname && count === 0 && urlArr[urlArr.length - 1] === '/') {
        // pathname 为 空字符串
        // 且url里只有一个/
        // 且 /在最后
        // 过滤掉/
        nUrl = urlArr.filter((item) => item !== '/').join('');
      }
      // 把星替换成正则
      // 然后与当前的hostname + pathname进行匹配
      // return匹配结果
      // 修复java和js正则执行差异
      if (nUrl?.length > 0) {
        if (nUrl[0] !== '*') {
          nUrl = '^' + nUrl;
        }
        if (nUrl[nUrl.length - 1] !== '*') {
          nUrl = nUrl + '$';
        }
      }
      const regStr = nUrl.replaceAll('*', '(?:.*)');
      const reg = new RegExp(regStr);
      log('matchExactUrl reg match url=%s regStr=%s', hostname + pathname, regStr);
      return reg.test(hostname + pathname);
    }
  } else {
    // 勾选完全匹配 且 包含？
    // 和包含的逻辑一样
    return matchUrlPart(pathname, hostname, paramseters, urlItem.url);
  }
};

export const matchExactUrls = (pathname, hostname, paramseters, urls) => {
  for (let i = 0; i < urls.length; i++) {
    // url处理
    let urlItem = urls[i];
    if (matchExactUrl(pathname, hostname, paramseters, urlItem)) {
      return true;
    }
  }
  return false;
};

export const matchUrlParts = (pathname, hostname, paramseters, urls) => {
  for (let i = 0; i < urls.length; i++) {
    // url处理
    let urlItem = urls[i];
    if (matchUrlPart(pathname, hostname, paramseters, urlItem.url)) {
      return true;
    }
  }
  return false;
};

export const generageUrlFromPage = (pages) => {
  const qeualUrls = [];
  const includeUrls = [];
  for (let i = 0; i < pages.length; i++) {
    const page = pages[i];
    if (page === '1') {
      const urlItem = { url: '' };
      urlItem.url = window?.location?.hostname;
      qeualUrls.push(urlItem);

      if (isShopifyOrTest()) {
        if (window.Shopify?.routes?.root) {
          // 添加不带尾部斜杠的URL
          const urlItem = { url: '' };
          urlItem.url = window.location?.hostname + window.Shopify.routes.root.replace(/\/$/, '');
          qeualUrls.push(urlItem);
          log('add shopify root root=%s url=%s', window.Shopify.routes.root, urlItem.url);

          // 添加带尾部斜杠的URL
          const urlItemWithSlash = { url: '' };
          urlItemWithSlash.url = window.location?.hostname + window.Shopify.routes.root.replace(/\/$/, '') + '/';
          qeualUrls.push(urlItemWithSlash);
          log('add shopify root root=%s url=%s', window.Shopify.routes.root, urlItemWithSlash.url);
        }
      }

      if (isShoplazzaOrTest()) {
        if (window.SHOPLAZZA?.routes?.root) {
          // 添加不带尾部斜杠的URL
          const urlItem = { url: '' };
          urlItem.url = window.location?.hostname + window.SHOPLAZZA.routes.root.replace(/\/$/, '');
          qeualUrls.push(urlItem);
          log('add shoplazza root=%s url=%s', window.SHOPLAZZA.routes.root, urlItem.url);

          // 添加带尾部斜杠的URL
          const urlItemWithSlash = { url: '' };
          urlItemWithSlash.url = window.location?.hostname + window.SHOPLAZZA.routes.root.replace(/\/$/, '') + '/';
          qeualUrls.push(urlItemWithSlash);
          log('add shoplazza root=%s url=%s', window.SHOPLAZZA.routes.root, urlItemWithSlash.url);
        }
      }

      if (isShoplineOrTest()) {
        if (window.Shopline?.routes?.root) {
          // 添加不带尾部斜杠的URL
          const urlItem = { url: '' };
          urlItem.url = window.location?.hostname + window.Shopline.routes.root.replace(/\/$/, '');
          qeualUrls.push(urlItem);
          log('add shopline root=%s url=%s', window.Shopline.routes.root, urlItem.url);

          // 添加带尾部斜杠的URL
          const urlItemWithSlash = { url: '' };
          urlItemWithSlash.url = window.location?.hostname + window.Shopline.routes.root.replace(/\/$/, '') + '/';
          qeualUrls.push(urlItemWithSlash);
          log('add shopline root=%s url=%s', window.Shopline.routes.root, urlItemWithSlash.url);
        }
      }

      if (isCommonSimpleOrTest() && isInPage('home')) {
        const urlItem = { url: '' };
        urlItem.url = `*${window.location.pathname}*`;
        includeUrls.push(urlItem);
      }
    } else if (page === '2') {
      const urlItem = { url: '' };
      urlItem.url = '*/collection/*';
      includeUrls.push(urlItem);

      const urlItem1 = { url: '' };
      urlItem1.url = '*/collections/*';
      includeUrls.push(urlItem1);

      // wooCommerce特殊适配
      if (isWooCommerceOrTest()) {
        const urlItem2 = { url: '' };
        urlItem2.url = '*/product-category/*';
        includeUrls.push(urlItem2);

        const urlItem3 = { url: '' };
        urlItem3.url = '*/product-tag/*';
        includeUrls.push(urlItem3);
      }

      if (isCommonSimpleOrTest()) {
        if ([...SMALLRIG].includes(companyUUID)) {
          const urlItem2 = { url: '' };
          urlItem2.url = '*/list/*';
          includeUrls.push(urlItem2);
        } else if (isSimpleOrTest()) {
          if (isInPage('collection')) {
            includeUrls.push({
              url: `*${window.location.pathname}*`
            });
          }
        }
      }
    } else if (page === '3') {
      const urlItem = { url: '' };
      urlItem.url = '*/product/*';
      includeUrls.push(urlItem);

      const urlItem1 = { url: '' };
      urlItem1.url = '*/products/*';
      includeUrls.push(urlItem1);

      if (
        isCommonSimpleOrTest()
      ) {
        if (isInPage('detail')) {
          includeUrls.push({
            url: `*${window.location.pathname}*`
          });
        }
      }
    } else if (page === '4') {
      if (isCommonOrTest() && [common[2558]].includes(companyUUID)) {
        const urlItem = { url: '' };
        urlItem.url = '*/checkout/cart/*';
        includeUrls.push(urlItem);
      } else if (
        isCommonSimpleOrTest() &&
        isInPage('cart')
      ) {
        includeUrls.push({
          url: `*${window.location.pathname}*`
        });
      } else {
        const urlItem = { url: '' };
        urlItem.url = '*/cart/*';
        includeUrls.push(urlItem);

        const urlItem1 = { url: '' };
        urlItem1.url = '*/carts/*';
        includeUrls.push(urlItem1);
      }
    } else if (page === '5') {
      if (isCommonOrTest() && [common[2558]].includes(companyUUID)) {
        const urlItem = { url: '' };
        urlItem.url = '*/checkout/shipping/*';
        includeUrls.push(urlItem);
      } else if (
        isCommonSimpleOrTest() &&
        isInPage('checkout')
      ) {
        includeUrls.push({
          url: `*${window.location.pathname}*`
        });
      } else {
        const urlItem = { url: '' };
        urlItem.url = '*/checkout/*';
        includeUrls.push(urlItem);

        const urlItem1 = { url: '' };
        urlItem1.url = '*/checkouts/*';
        includeUrls.push(urlItem1);
      }

      if (isCommonOrTest() && [...POVISON].includes(companyUUID)) {
        const urlItem2 = { url: '' };
        urlItem2.url = '*/payMobile/*';
        includeUrls.push(urlItem2);
      }

      if (isCommonOrTest() && [...SMALLRIG].includes(companyUUID)) {
        const urlItem2 = { url: '' };
        urlItem2.url = '*/payment/*';
        includeUrls.push(urlItem2);
      }
    }
  }
  return [qeualUrls, includeUrls];
};

const reportPopupPageReject = (popItem, result) => {
  formEventV2({
    event: 'popup_h5_result',
    triggerEventType: popItem?.triggerEventType,
    formId: popItem?.id,
    formName: popItem?.name,
    result
  })
    .then(() => {})
    .catch(() => {});
};

/**
 * 弹窗页面规则是否允许当前页展示
 * @param silent true 时不打 popup_h5_result（供 icon 复用）
 */
export const isPopupPageAllowed = (popItem, options: { silent?: boolean } = {}) => {
  const silent = !!options.silent;
  let hostname = window?.location?.hostname;
  let pathname = window?.location?.pathname;
  let paramseters = window?.location?.search;
  // hostname处理
  if (hostname) {
    // 去除https//、http//和www.
    hostname = hostname.replaceAll('https://', '');
    hostname = hostname.replaceAll('http://', '');
    hostname = hostname.replaceAll('www.', '');
  }
  // 为空处理
  if (!hostname) {
    hostname = '';
  }
  if (!pathname) {
    pathname = '';
  }
  if (!paramseters) {
    paramseters = '';
  }
  // 页面路径逻辑，符合页面路径逻辑的才能被拿到，进入下一轮判断
  if (popItem.settings?.targeting) {
    // 非特定页逻辑
    if (popItem.settings?.targeting?.excludeUrls?.length > 0) {
      if (matchExactUrls(pathname, hostname, paramseters, popItem.settings?.targeting?.excludeUrls)) {
        if (!silent) {
          reportPopupPageReject(popItem, '满足非特定页配置');
        }
        return false;
      }
    }
    if (popItem.settings?.targeting?.excludeUrlParts?.length > 0) {
      if (matchUrlParts(pathname, hostname, paramseters, popItem.settings?.targeting?.excludeUrlParts)) {
        if (!silent) {
          reportPopupPageReject(popItem, '满足非特定页配置');
        }
        return false;
      }
    }
    const openPageCheck = true;
    if (openPageCheck && popItem.settings?.targeting?.excludePages?.length > 0) {
      // 简单设置的非特定页
      const [urls, includeUrls] = generageUrlFromPage(popItem.settings?.targeting?.excludePages);
      if (urls.length > 0) {
        if (matchExactUrls(pathname, hostname, paramseters, urls)) {
          if (!silent) {
            reportPopupPageReject(popItem, '满足非特定页配置');
          }
          return false;
        }
      }
      if (includeUrls.length > 0) {
        if (matchUrlParts(pathname, hostname, paramseters, includeUrls)) {
          if (!silent) {
            reportPopupPageReject(popItem, '满足非特定页配置');
          }
          return false;
        }
      }
    }

    // 特定页逻辑
    if (popItem.settings?.targeting?.urls?.length > 0) {
      if (matchExactUrls(pathname, hostname, paramseters, popItem.settings?.targeting?.urls)) {
        return true;
      }
    }
    if (popItem.settings?.targeting?.urlParts?.length > 0) {
      if (matchUrlParts(pathname, hostname, paramseters, popItem.settings?.targeting?.urlParts)) {
        return true;
      }
    }
    if (openPageCheck && popItem.settings?.targeting?.pages?.length > 0) {
      // 简单设置的特定页
      const [urls, includeUrls] = generageUrlFromPage(popItem.settings?.targeting?.pages);
      if (urls.length > 0) {
        if (matchExactUrls(pathname, hostname, paramseters, urls)) {
          return true;
        }
      }
      if (includeUrls.length > 0) {
        if (matchUrlParts(pathname, hostname, paramseters, includeUrls)) {
          return true;
        }
      }
    }
    // 如果没有特定页逻辑，直接展示
    if (
      popItem.settings?.targeting?.urls?.length === 0 &&
      popItem.settings?.targeting?.urlParts?.length === 0 &&
      ((openPageCheck && ((!!popItem.settings?.targeting?.pages && popItem.settings?.targeting?.pages?.length === 0) || !popItem.settings?.targeting?.pages)) || !openPageCheck)
    ) {
      // 没有设置在特定页展示
      return true;
    }
  }
  if (!silent) {
    reportPopupPageReject(popItem, '不满足展示页面配置');
  }
  return false;
};

const checkUrl = (popItem) => isPopupPageAllowed(popItem, { silent: false });

const checkUser = (popItem) => {
  // 判断用户状态
  if (popItem.settings?.rules?.subscribedSubscriber && popItem.settings?.rules?.unsubscribedSubscriber) {
    // 订阅不订阅都展示，不管
    return true;
    // console.log('订阅不订阅都展示');
  } else if (popItem.settings?.rules?.subscribedSubscriber) {
    // console.log('订阅');
    // 目前使用cid判断，以后使用cookie判断
    // 641、30、1081，关闭cid清除逻辑
    if (companyUUID !== 'lom9e5qw' && companyUUID !== 'l2y7m6c5' && companyUUID !== 'lwq5wwol') {
      if (getLocal(STORAGE_KEY.CID) || getLocal(STORAGE_KEY.FORM_UID)) {
        return true;
      }
    } else {
      if (getLocal(STORAGE_KEY.FORM_UID)) {
        return true;
      }
    }
  } else if (popItem.settings?.rules?.unsubscribedSubscriber) {
    // console.log('未订阅');
    // 641、30、1081，关闭cid清除逻辑
    if (companyUUID !== 'lom9e5qw' && companyUUID !== 'l2y7m6c5' && companyUUID !== 'lwq5wwol') {
      if (getLocal(STORAGE_KEY.CID) || getLocal(STORAGE_KEY.FORM_UID)) {
      } else {
        return true;
      }
    } else {
      if (getLocal(STORAGE_KEY.FORM_UID)) {
      } else {
        return true;
      }
    }
  }
  formEventV2({
    event: 'popup_h5_result',
    triggerEventType: popItem?.triggerEventType,
    formId: popItem?.id,
    formName: popItem?.name,
    result: '订阅状态'
  })
    .then((response) => {
      // console.log('数据上报成功')
    })
    .catch((e) => {});
  // console.log('订阅状态');
  return false;
};

const checkTerminal = (popItem) => {
  // 移动端pc端逻辑
  if (popItem.settings?.rules?.terminalType === 'all') {
    // console.log('端判断，全部客户端');
    return true;
  } else if (popItem.settings?.rules?.terminalType === 'pc') {
    // console.log('端判断，pc端');
    if (terminal) {
      return true;
    }
  } else if (popItem.settings?.rules?.terminalType === 'mobile') {
    // console.log('端判断，mobile端');
    if (!terminal) {
      return true;
    }
  }
  formEventV2({
    event: 'popup_h5_result',
    triggerEventType: popItem?.triggerEventType,
    formId: popItem?.id,
    formName: popItem?.name,
    result: '设备类型'
  })
    .then((response) => {
      // console.log('数据上报成功')
    })
    .catch((e) => {});
  // console.log('设备类型');
  return false;
};

export const checkTimeRange = (popItem) => {
  if (popItem.settings?.targeting?.scheduleType !== 1) {
    // 永远生效
    return true;
  }
  // 时间段限制
  if (popItem.settings?.targeting?.startTime && popItem.settings?.targeting?.endTime) {
    // 如果没有结束时间，则认为永远生效
    if (!popItem.settings?.targeting?.endTime) {
      return true;
    }
    const startTime = new Date(popItem.settings?.targeting?.startTime);
    const endTime = new Date(popItem.settings?.targeting?.endTime);
    const currentTime = new Date();
    if (currentTime >= startTime && currentTime <= endTime) {
      return true;
    }
  }

  formEventV2({
    event: 'popup_h5_result',
    triggerEventType: popItem?.triggerEventType,
    formId: popItem?.id,
    formName: popItem?.name,
    result: '时间限制',
    remark: `${popItem.settings?.targeting?.startTime} - ${popItem.settings?.targeting?.endTime}`
  })
    .then((response) => {
      // console.log('数据上报成功')
    })
    .catch((e) => {});
  return false;
};

// 策略器，触发弹窗取配置
// 因为可能同时触发多个弹窗，使用订阅模式制作策略器
class PopTrigger {
  /**
   * 触发列表
   */
  triggerList: any;

  /**
   * 获取配置
   */
  requesting: any;

  /**
   * 请求
   */
  request: any;

  /**
   * 匹配状态
   */
  matching: any;

  /**
   * 本地配置
   */
  config: any;

  /**
   * 首次触发
   */
  firstTrigger: any;

  /**
   * 配置校验数量
   */
  checkConfigCount: any;

  /**
   * 配置校验列表
   */
  checkConfigList: any;

  /**
   * 加载开始时间
   */
  loadStartTime: any;

  /**
   * 获取响应
   */
  getResponse: any;

  /**
   * 选项
   */
  options: any;

  constructor() {
    // 触发列表
    this.triggerList = {};
    // 获取配置
    this.requesting = false;
    // 匹配状态
    this.matching = false;
    // 本地配置
    this.config = false;
    // 增加首次触发逻辑，用于判断是否首次触发
    this.firstTrigger = false;
    // 配置校验数量
    this.checkConfigCount = 0;
    // 配置校验列表
    this.checkConfigList = [];
    this.loadStartTime = null;
    this.getResponse = null;
  }
  // 触发器，只有触发，没有取消触发，未来使用打断器进行打断
  trigger(type, fn, loadStartTime, getResponse, options = {}) {
    // 自定义弹窗依赖formId，防止其他弹窗覆盖
    if (this.options?.formId && type !== 8) {
      this.options = { formId: this.options?.formId, ...options };
    } else {
      this.options = options;
    }

    popupFlowLog(
      'PopTrigger.trigger type=%s trigger=%s firstTrigger=%s checkConfigList=%o',
      type,
      (options as any)?.trigger ?? '',
      this.firstTrigger,
      this.checkConfigList
    );
    // console.log('触发', type);
    if (!this.triggerList[type]) {
      this.triggerList[type] = [fn];
    } else {
      this.triggerList[type].push(fn);
    }
    if (`${type}` === '0') {
      this.loadStartTime = loadStartTime;
      this.getResponse = getResponse;
    }

    // 校验配置，开关
    // 12月8日全量所有
    // 全量所有渠道就是开关直接打开，不再加判断
    const getNewConfig = true;
    // 首次请求不需要校验配置，校验配置前
    if (getNewConfig && !this.firstTrigger) {
      // 按照类型维护，如果没请求过此类型，才会加入校验
      if (!this.checkConfigList.includes(type)) {
        // console.log('检查类型', type);
        // 加入类型就校验列表
        this.checkConfigList.push(type);
        // 需要每次请求配置
        checkConfigFrom(type)
          .then((res) => {
            // console.log('更新', type, res);
            // 更新配置
            this.config = res;
          })
          .catch(() => {
            // console.log('请求失败');
          })
          .finally(() => {
            // 所有配置都检查完了，再走触发逻辑
            this.checkConfigCount += 1;
            const types = Object.keys(this.triggerList || {});
            // 数量和触发数量一致
            if (this.checkConfigCount === types.length) {
              // console.log('完成所有检查');
              // 每次检查均需要进行04检查，如果符合04检查，还需要新请求转来的04配置
              if (this.resetType04()) {
                // 根据后端设置重置了0和4
                const nType = this.checkConfigList.includes(0) ? 4 : 0;
                // 单独请求一下最新配置
                checkConfigFrom(nType)
                  .then((res) => {
                    // console.log('更新0或4', nType, res);
                    // 更新配置
                    this.config = res;
                  })
                  .catch(() => {
                    // console.log('请求失败');
                  })
                  .finally(() => {
                    // 重置0和4
                    // 清空校验列表和计数
                    this.checkConfigCount = 0;
                    this.checkConfigList = [];
                    // 触发
                    this.match(type);
                  });
              } else {
                // 未重置0和4
                // 清空校验列表和计数
                this.checkConfigCount = 0;
                this.checkConfigList = [];
                // 触发
                this.match(type);
              }
            }
          });
      }
    } else {
      // 加入完自动触发
      this.match(type);
    }
  }
  resetType1() {
    const types = Object.keys(this.triggerList || {});
    for (let i = 0; i < types?.length; i++) {
      const type = types[i];
      // 1可以是：弃单或离开
      if (`${type}` === '1') {
        // 走1或5的判断
        // 1：查一下 有没有弃单开启的弹窗（配置列表里有没有type为5的弹窗，如果没有还是1，如果有的话）
        // 2：看现在的页面路径是否匹配弃单的页面路径，如果成功，则改type为5，如果没有则还是1
        // 由于2的步骤，不能在这里判断，需要在配置结果里判断
        for (let i = 0; i < this.config?.rets?.length; i++) {
          const popItem = this.config.rets[i];
          // 根据类型取弹窗数据
          if (`${popItem?.triggerEventType}` === '5') {
            // 查看页面路径是否匹配
            if (checkUrl(popItem)) {
              // 如果匹配，type改为5，且跳出
              const triggers1 = this.triggerList['1'] || [];
              if (this.triggerList['5']) {
                const triggers5 = this.triggerList['5'] || [];
                this.triggerList['5'] = triggers1.concat(triggers5);
              } else {
                this.triggerList['5'] = triggers1;
              }
              delete this.triggerList['1'];
              return;
            }
          }
        }
      }
    }
  }
  resetType04() {
    const types = Object.keys(this.triggerList || {});
    // 4=老用户弹窗 0=新手订阅弹窗，二者互斥，有 cid/formUid 时把 0 转 4，无则把 4 转 0
    if (types?.includes('4')) {
      // 老用户弹窗
      if (!(getLocal(STORAGE_KEY.CID) || getLocal(STORAGE_KEY.FORM_UID))) {
        // 没有cid和formUid，转为0
        const triggers4 = this.triggerList['4'] || [];
        if (this.triggerList['0']) {
          const triggers0 = this.triggerList['0'] || [];
          this.triggerList['0'] = triggers4.concat(triggers0);
        } else {
          this.triggerList['0'] = triggers4;
        }
        delete this.triggerList['4'];
        return true;
      }
    } else if (types?.includes('0')) {
      // 新用户和老用户不会同时触发
      // 新手订阅弹窗
      if (getLocal(STORAGE_KEY.CID) || getLocal(STORAGE_KEY.FORM_UID)) {
        // 有cid和formUid，转为4
        const triggers0 = this.triggerList['0'] || [];
        if (this.triggerList['4']) {
          const triggers4 = this.triggerList['4'] || [];
          this.triggerList['4'] = triggers0.concat(triggers4);
        } else {
          this.triggerList['4'] = triggers0;
        }
        delete this.triggerList['0'];
        return true;
      }
    }
    return false;
  }
  match(type?: number) {
    // console.log('匹配');
    // 如果有配置
    if (this.config && checkCoupnMatchConfig()) {
      if (this.matching === false) {
        // console.log('开始匹配');
        // 匹配中
        this.matching = true;

        // 全局上限、全局静默的配置
        // 6/8=点击触发，不参与全局弹窗上限校验（canShowAll）
        const canShowAll = canShowAnyPop(this.config) || [6, 8].includes(type);
        const types = Object.keys(this.triggerList || {});

        popupFlowLog(
          'match begin requestedType=%s canShowAll=%s triggerTypes=%o retsCount=%s',
          type,
          canShowAll,
          types,
          this.config?.rets?.length ?? 0
        );

        // 显示逻辑
        // 多订阅弹窗开关，30、721、565
        // 0118 多订阅弹窗全量上线
        const showLogic = true;
        if (showLogic) {
          if (!canShowAll && types.includes('0')) {
            // 静默期中，如果是0的弹窗，不走静默期，直接等待
            const typeTriggers = this.triggerList['0'];
            this.triggerList = {};
            this.triggerList['0'] = typeTriggers;
          }
        }
        if (!canShowAll && (!showLogic || !types.includes('0'))) {
          popupFlowLog(
            'match blocked by global silent/limits (non-type0 path) canShowAll=false triggerTypes=%o requestedType=%s',
            types,
            type
          );
        }
        if (canShowAll || (!canShowAll && showLogic && types.includes('0'))) {
          // 根据优先级，匹配出发类型，获取配置
          let popConfig = null;
          let popType = -1;

          // 因为现有逻辑，type==1，可能是离开也可能是弃单，所以需要重置type
          this.resetType1();

          if (this.firstTrigger) {
            // 第一次请求的时候，对比本地cid、formUid，进行04转换
            this.resetType04();
          }

          // 拿到本地的触发列表
          const types = Object.keys(this.triggerList || {});
          const ranks = this.config?.ranks || [];
          // console.log('拿到的触发', types);

          const triggerPop0s = [];

          // 根据优先级依次取
          for (let i = 0; i < ranks.length; i++) {
            const type = ranks[i];

            // 如果触发器中存在优先级高的
            if (types.includes(`${type}`)) {
              // 查询这个类型的配置，配置的优先级竞争
              // console.log(type);

              let tempPop = null;
              let tempType = null;
              // 找到这个配置
              for (let i = 0; i < this.config?.rets?.length; i++) {
                const popItem = this.config.rets[i];

                // 根据类型取弹窗数据
                if (`${popItem?.triggerEventType}` === `${type}`) {
                  // debugger
                  // 取到临时配置和类型，去进行优先级、打断等逻辑判断
                  if (popItem) {
                    // 后端迁到前端的逻辑

                    // 8 类型弹窗，如果id不匹配，则不展示
                    if (type === 8) {
                      if (popItem.id !== this.options?.formId) {
                        log('trigger custom popup not match current=%s options.formId=%s', popItem.id, this.options?.formId);
                        continue;
                      }
                      popType = type;
                      popConfig = popItem;
                      break;
                    }

                    if (type === 6) {
                      popType = type;
                      popConfig = popItem;
                      break;
                    }
                    const disableCheckUrl = `${type}` === '2' && popItem?.settings.rules.addPurchaseJumpPageShow && this.options?.trigger !== 'jump';
                    /**
                     * 策略：
                     * 新手弹窗：判断用户状态
                     * 加购弹窗：判断页面路径
                     * 其他：判断行为等
                     */
                    // 路径匹配
                    // 配置加购跳转展示
                    // console.log('拦截状态', checkUrl(popItem), disableCheckUrl);
                    if (!checkUrl(popItem) && !disableCheckUrl) {
                      // 如果页面路径不匹配，请求下一个弹窗
                      if (`${type}` === '2') {
                        // 清除加购标记
                        removeSession(STORAGE_KEY.ADD_CART_STATE);
                      }
                      continue;
                    }

                    if (popItem.type === 'POP_WINDOW') {
                      // 只有弹窗走如下逻辑，转盘不走
                      // console.log('判断用户状态');
                      // 判断用户状态
                      if (!checkUser(popItem)) {
                        // 如果用户状态不匹配，请求下一个弹窗
                        if (`${type}` === '2') {
                          // 清除加购标记
                          removeSession(STORAGE_KEY.ADD_CART_STATE);
                        }
                        continue;
                      }

                      // 检查pc、移动端
                      if (!checkTerminal(popItem)) {
                        // 如果pc移动端不匹配，请求下一个弹窗
                        if (`${type}` === '2') {
                          // 清除加购标记
                          removeSession(STORAGE_KEY.ADD_CART_STATE);
                        }
                        continue;
                      }

                      // 检查时间段限制
                      // if (!checkTimeRange(popItem)) {
                      //   // 如果时间段限制不匹配，请求下一个弹窗
                      //   if (`${type}` === '2') {
                      //     // 清除加购标记
                      //     removeSession(STORAGE_KEY.ADD_CART_STATE);
                      //   }
                      //   continue;
                      // }
                    }
                    tempPop = popItem;
                    tempType = type;
                    // console.log('临时配置', popItem);
                    // 找到就判断两次间隔

                    if (tempPop && tempPop?.type === 'POP_WINDOW') {
                      // console.log('tempPop', tempPop);
                      // 触发打断逻辑，能不能显示这个弹窗
                      if (tempPop && canShowThisPop(tempPop, tempType)) {
                        // 预先渲染「显示前」Icon：让弹窗下发前能看到icon
                        if (tempPop?.settings?.position?.iconShow === 1) {
                          try {
                            const canShowIconBefore = canShowIconBeforeWithFrequency(
                              tempPop?.settings?.position?.iconTiming,
                              tempPop
                            );
                            if (canShowIconBefore) {
                              // showIcon 依赖 _cartsee_tempPop
                              localStorage?.setItem('_cartsee_tempPop', JSON.stringify(tempPop));

                              // 避免重复创建容器
                              if (!document?.querySelector('#cartx-icon')) {
                                const upgradeLoad = (window as any).__cartsee_upgradeLoad;
                                log('pre-render icon for popup id=%s', tempPop?.id);
                                showIcon(upgradeLoad);
                              }
                            }
                          } catch (e) {}
                        }
                        if (showLogic) {
                          // 多弹窗逻辑增加规则：多折扣码弹窗第二步的弹窗需要被多弹窗屏蔽掉~
                          if (`${type}` === '0') {
                            if (tempPop?.combinationType !== 2) {
                              triggerPop0s.push(tempPop);
                            }
                            continue;
                          }
                        }
                        popType = tempType;
                        popConfig = tempPop;
                        // 符合条件跳出，拿到了优先级最高的配置
                        // console.log('最后结果', popConfig);
                        break;
                      }
                    } else if (tempPop && tempPop?.type === 'WheelOfFortune') {
                      if (showLogic) {
                        // 多弹窗逻辑增加规则：多折扣码弹窗第二步的弹窗需要被多弹窗屏蔽掉~
                        if (`${type}` === '0') {
                          if (tempPop?.combinationType !== 2) {
                            triggerPop0s.push(tempPop);
                          }
                          continue;
                        }
                      }
                      // 转盘不走两次间隔逻辑
                      popType = tempType;
                      popConfig = tempPop;
                      // 符合条件跳出，拿到了优先级最高的配置
                      // console.log('最后结果', popConfig);
                      break;
                    }
                  }
                }
              }
              if (triggerPop0s.length > 0) {
                popType = type;
                popConfig = null;
                break;
              }

              if (popConfig) {
                // 拿到最终配置直接跳出
                break;
              }
            }
          }

          // 如果有最终配置
          if (popConfig || triggerPop0s.length > 0) {
            if (`${popType}` !== '2') {
              // 在有加购的情况下，触发到了其他弹窗，说明其他弹窗优先级更高，则清除加购标记，让下一次加购起作用。
              if (getSession(STORAGE_KEY.ADD_CART_STATE) === '1') {
                removeSession(STORAGE_KEY.ADD_CART_STATE);
              }
            }
            // 普通触发
            if (popConfig) {
              // 取出触发回调
              const typeTriggers = this.triggerList[popType];
              if (typeTriggers && typeTriggers.length > 0) {
                // 同类型，最后一次触发的能拿到
                const lastTrigger = typeTriggers[typeTriggers.length - 1];
                // 触发
                if (lastTrigger) {
                  popupFlowLog(
                    'match invoke callback popType=%s popId=%s popName=%s',
                    popType,
                    popConfig?.id,
                    popConfig?.name
                  );
                  lastTrigger(popConfig);
                }
              } else {
                popupFlowLog(
                  'match has popConfig but no typeTriggers popType=%s popId=%s',
                  popType,
                  popConfig?.id
                );
              }
              const triggerPop = getLocal(STORAGE_KEY.TEMP_POP);
              if (triggerPop) {
                const tempConfig = safeJsonParse<any>(triggerPop, {} as any);
                // 有配置，不再管，因为悬浮窗和弹窗不是一个
                // if (`${popType}` === 0 || `${popType}` === 4) {
                //   console.log('同类型弹窗触发，如果是同一弹窗，静默或两次间隔过了；如果是不同弹窗，则优先级调了，以后优先级都会弹新的，清除悬浮框');
                //   // console.log('显示弹窗与触发icon一致，静默期和两次间隔已过，清除icon');
                //   removeLocal(STORAGE_KEY.TEMP_POP);
                //   // 两次间隔过了，清除dom
                //   document?.querySelector('#cartx-icon')?.remove();
                //   deleteDOM('cartx-wrap');
                // }
                // 同一个弹窗触发的话，说明两次间隔过了，需要清除掉悬浮窗
                if (popConfig.id === tempConfig.id) {
                  // console.log('显示弹窗与触发icon一致，静默期和两次间隔已过，清除icon');
                  // 同一个悬浮窗
                  removeLocal(STORAGE_KEY.TEMP_POP);
                  // 两次间隔过了，清除dom
                  document?.querySelector('#cartx-icon')?.remove();
                  deleteDOM('cartx-wrap');
                  // 清除加购弹窗
                  deleteDOM('cartx-purchase-wrap');
                }
              }
            }
            // 多订阅触发
            if (triggerPop0s.length > 0) {
              // 满足触发的多订阅
              // 取出0类型的触发回调
              // const typeTriggers = this.triggerList[popType];
              // if (typeTriggers && typeTriggers.length > 0) {
              //   // 同类型，最后一次触发的能拿到
              //   const lastTrigger = typeTriggers[typeTriggers.length - 1];
              //   // 由显示逻辑维护触发
              //   if (this.getResponse) {
              //     showFromTriggerList(triggerPop0s, this.getResponse, this.loadStartTime);
              //   }
              // }
              if (this.getResponse) {
                popupFlowLog(
                  'match showFromTriggerList count=%s ids=%s options.trigger=%s',
                  triggerPop0s.length,
                  triggerPop0s.map((p: any) => p?.id).join(','),
                  this.options?.trigger ?? ''
                );
                showFromTriggerList(triggerPop0s, this.getResponse, this.loadStartTime, this.config, this.options);
              } else {
                popupFlowLog('match triggerPop0s length=%s but getResponse missing', triggerPop0s.length);
              }
            }
          }
          if (!popConfig && triggerPop0s.length === 0) {
            popupFlowLog(
              'match no winner popConfig=null triggerPop0s=0 requestedType=%s triggerTypes=%o',
              type,
              Object.keys(this.triggerList || {})
            );
          }
        }

        // 清除此次的触发列表
        this.triggerList = {};
        // 允许重新触发匹配
        this.matching = false;
        // 下次从getSessionConfig请求配置触发的匹配，仍是首次触发
        this.firstTrigger = false;
      }
    } else if (this.requesting === false) {
      // 如果没有配置，未在请求，则进行请求
      this.requesting = true;
      this.firstTrigger = true;
      // 每次都请求新的配置
      getSessionConfig()
        .then((res) => {
          // 拿到配置，重新触发配置渲染
          this.requesting = false;
          this.config = res;
          this.match();
        })
        .catch(() => {
          // 请求3次都失败了，就没必要触发了
          this.triggerList = {};
          // 允许后续触发重新match
          this.requesting = false;
        });
    }
  }
}

const trigger = new PopTrigger();

// 获取弹窗配置，唤起触发器
// 封装为promise调用方便
const getPopupConfig = (type, loadStartTime, getResponse, options = {}) => {
  // 优先级
  // TODO: 不满足多触发条件
  const promise = new Promise((resolve, reject) => {
    // 触发
    log('trigger popup type=%d', type);
    popupFlowLog('getPopupConfig enqueue type=%s loadStartTime=%s options=%o', type, loadStartTime, options);
    // prettier-ignore
    trigger.trigger(type, (popConfig) => {
      log('trigger a popup type=%d id=%s name=%s', type, popConfig?.id, popConfig?.name);
      popupFlowLog(
        'getPopupConfig callback type=%s popId=%s popName=%s triggerEventType=%s',
        type,
        popConfig?.id,
        popConfig?.name,
        popConfig?.triggerEventType
      );
      const okLeave = popConfig ? leavePopVerify(type, popConfig) : false;
      const okAddCart = popConfig ? addCartTriggerVerify(type, popConfig, options) : false;
      const okPrefetch = popConfig ? prefetchTriggerVerify(type, popConfig, options) : false;
      if (popConfig && okLeave && okAddCart && okPrefetch) {
        // 有配置，需要弹
        popupFlowLog('getPopupConfig resolve type=%s popId=%s', type, popConfig?.id);
        resolve(popConfig);
      } else {
        // 关闭弹窗或未配置 6/8=点击触发，关闭时清除 soldOut 配置
        if (type === 6 || type === 8) {
          removeSession(STORAGE_KEY.SOLD_OUT_POPUP_CONFIG);
        }
        // 没有，不弹了
        const reasonParts: string[] = [];
        if (!popConfig) reasonParts.push('no_popConfig');
        else {
          if (!okLeave) reasonParts.push('leavePopVerify=false');
          if (!okAddCart) reasonParts.push('addCartTriggerVerify=false');
          if (!okPrefetch) reasonParts.push('prefetchTriggerVerify=false');
        }
        popupFlowLog(
          'getPopupConfig reject type=%s reason=%s popId=%s options=%o',
          type,
          reasonParts.join('|') || 'unknown',
          popConfig?.id,
          options
        );
        // TODO: 上线前移除调试日志
        console.warn('[cartx:getPopupConfig] reject type=%s reason=%s options=%o popId=%s', type, reasonParts.join('|') || 'unknown', options, popConfig?.id);
        reject(new Error(`getPopupConfig_reject:${reasonParts.join('|') || 'unknown'}`));
      }
    }, loadStartTime, getResponse, options);
  });
  return promise;
};

const leavePopVerify = (type, popConfig) => {
  // if(type === 1 && ['l2y7m6c5', 'l2y7m6c5', 'lt72sdrv', 'lx057zya'].includes(companyUUID)){
  if (type === 1) {
    const sessionAllPop = window?.sessionStorage?.getItem('allPopCount') || 0;
    const sessionLeavePop = window?.sessionStorage?.getItem('leavePopCount') || 0;
    const rulesConfig = popConfig.settings.rules;
    let pdStstus = 0;
    let intercept = [];

    // 开启根据所有弹窗弹出次数过滤，并且当前会话弹窗次数不超过配置数
    if (rulesConfig.stopDisplayConditionShowAllFormFilter) {
      if (Number(sessionAllPop) < rulesConfig.stopDisplayConditionShowAllFormCount) {
        console.log('符合所有弹窗次数的条件');
      } else {
        intercept.push('all');
        pdStstus++;
      }
    }

    // 开启根据退出挽留场景弹窗弹出次数过滤，并且当前会话弹窗次数不超过配置数
    if (rulesConfig.stopDisplayConditionShowCurrentFormFilter) {
      if (Number(sessionLeavePop) < rulesConfig.stopDisplayConditionShowCurrentFormCount) {
        console.log('符合此场景弹窗次数的条件');
      } else {
        intercept.push('current');
        pdStstus++;
      }
    }

    console.log(!pdStstus, '执行返回true,不执行返回false');
    if (pdStstus) {
      formEventV2({
        event: 'popup_h5_result',
        triggerEventType: popConfig?.triggerEventType,
        formId: popConfig?.id,
        formName: popConfig?.name,
        result: intercept.indexOf('all') > -1 ? 'session总曝光数' : 'session本场景曝光数'
      })
        .then((response) => {
          // console.log('数据上报成功')
        })
        .catch((e) => {});
    }

    return !pdStstus;
  } else {
    console.log('场景或者UUID不匹配，直接返回true');
    return true;
  }
};

export function isOldJumpAddCart() {
  const isMatchEnv = isSaaSPlatform();
  // 加购跳转到/cart
  return isMatchEnv && window?.location?.pathname?.indexOf('/cart') !== -1;
}

// 加购触发校验：跳转展示场景下写 session 标记与 URL，避免同页重复弹
const addCartTriggerVerify = (type, popConfig, options: any = {}) => {
  if (type === 2 && popConfig?.settings.rules.addPurchaseJumpPageShow) {
    const addCartJumpFlagUrl = getSession(STORAGE_KEY.ADD_CART_URL);
    const addCartExternalRes = getSession(STORAGE_KEY.CART_LAST_IMAGE);

    if (addCartJumpFlagUrl !== window.location.href && options.trigger === 'jump') {
      return true;
    } else if (isOldJumpAddCart()) {
      if (checkUrl(popConfig)) {
        return true;
      } else {
        setSession(STORAGE_KEY.ADD_CART_JUMP, '1');
        setSession(STORAGE_KEY.ADD_CART_URL, document.referrer);
        removeSession(STORAGE_KEY.ADD_CART_STATE);
        return false;
      }
    }

    setSession(STORAGE_KEY.ADD_CART_JUMP, '1');
    setSession(STORAGE_KEY.ADD_CART_URL, window.location.href);
    removeSession(STORAGE_KEY.ADD_CART_STATE);
    return false;
  } else {
    return true;
  }
};

export const SOLD_OUT_POPUP_CONFIG = '_cartsee_sold_out_popup_config';
const prefetchTriggerVerify = (type, popConfig, options: any = {}) => {
  if (type !== 6) {
    log('缺货弹窗：非缺货触发');
    return true;
  }

  // 拦截预加载
  if (options.trigger === 'prefetch') {
    setSession(STORAGE_KEY.SOLD_OUT_POPUP_CONFIG, JSON.stringify(popConfig));
    // console.log('缺货弹窗：预加载', popConfig);
    return false;
  } else {
    // console.log('缺货弹窗：展现');
    return true;
  }
};

export { getPopupConfig };
